import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, RefreshIcon, Spacing, styled, Typography } from 'ui';
import { ERROR_PAGE_CONTAINER } from './ErrorPage.testId';

const ContentWrapper = styled('div')`
  justify-content: center;
  align-items: center;
  display: flex;
  flex-flow: column;
  width: 100%;
  height: 100%;
`;

const StyledTypography = styled(Typography)`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing(Spacing.Large)};
  padding: ${({ theme }) => theme.spacing(Spacing.Medium)};
`;

type ErrorPageProps = {
  readonly title: string;
  readonly subtitle?: string;
  readonly reload?: boolean;
};

export function ErrorPage({ title, subtitle, reload }: ErrorPageProps) {
  const navigate = useNavigate();

  const handleReloadClick = useCallback(() => navigate(0), [navigate]);

  return (
    <ContentWrapper data-testid={ERROR_PAGE_CONTAINER}>
      <StyledTypography variant="h3">{title}</StyledTypography>
      <StyledTypography variant="subtitle">{subtitle}</StyledTypography>
      {reload ? (
        <Button
          aria-label="Refresh"
          endIcon={<RefreshIcon />}
          label="Refresh"
          onClick={handleReloadClick}
          variant="text"
        />
      ) : null}
    </ContentWrapper>
  );
}
